import { useContext } from "react";

import { QuoteContext } from "../context/QuoteContext";

export const useQuoteContext = () => {
  const context = useContext(QuoteContext);

  return context;
};
